<template>
	<div class="header-access-group-select">
		<app-select
			:model-value="store.currentAccessGroupId"
			:items="items"
			placeholder="Группа доступа"
			dropdown-class="header-select-dropdown"
			@update:model-value="onChange"
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import AppSelect, {
	SelectItem,
	SelectModelValue
} from "@/components/ui-kit/select/AppSelect.vue"
import { headerStore } from "@/store/header"

const store = headerStore()

const items = computed<SelectItem[]>(() =>
	store.accessGroups.map(g => ({ id: g.Id, label: g.Name }))
)

const onChange = (value: SelectModelValue) => {
	if (Array.isArray(value)) return
	store.setActiveAccessGroup(value == null ? null : Number(value))
}
</script>

<style scoped lang="scss">
.header-access-group-select {
	flex: 0 1 320px;
	min-width: 160px;
	max-width: 320px;

	:deep(.app-select__trigger) {
		background-color: #4D4D4D;
	}

	:deep(.app-select__single-value) {
		color: #fff;
	}

	:deep(.app-select__arrow svg path) {
		stroke: #D2D2D2;
	}
}
</style>

<style lang="scss">
.app-select__dropdown.header-select-dropdown {
	background-color: #4D4D4D;

	.app-select__option:not(.app-select__option--selected),
	.app-select__option--child:not(.app-select__option--selected) {
		color: #fff;
	}

	.app-select__option:hover,
	.app-select__option--focused {
		background-color: rgba(255, 255, 255, 0.08);
	}

	.app-select__option:not(.app-select__option--selected) .app-select__option-label span,
	.app-select__group-title {
		color: #fff;
	}
}
</style>
